import API, {
  GetUserAddressBookItemsPathForApi,
} from './api';

export const GetAddressBookItemsPromise = (organizationId, projectId, includeAddressBookItems,
  includeProjectMembers, includeProjectGroups, includeFields, includeFormTemplateFields, filter) => {

  let params = {
    organizationId,
    projectId,
    includeAddressBookItems,
    includeProjectMembers,
    includeProjectGroups,
    // Organization groups are usable anywhere project groups are
    includeOrganizationGroups: includeProjectGroups,
    includeFields,
    includeFormTemplateFields,
  };
  if (filter) {
    params.filter = filter;
  }
  return API.get(GetUserAddressBookItemsPathForApi(), { params })
    .then(resp => {
      return resp.data;
    })
}